import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  header: {
    main: {
      marginBottom: '1rem',
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1.5rem',
    },
    title: {
      width: '400px',
      height: '40px',
    },
  },
  locationSelector: {
    autoComplete: {
      marginBottom: '1.5rem',
    },
    box: {
      display: 'flex',
      justifyContent: 'center',
      padding: '1.5rem',
    },
    content: {
      width: '600px',
      display: 'flex',
      justifyContent: 'space-between',
    },
    text: {
      width: '250px',
      height: '40px',
    },
  },
  content: {
    main: {
      padding: '1.5rem',
    },
    row: {
      marginBottom: '1.5rem',
    },
    bar: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end',
    },
    barFirst: {
      height: '150px',
    },
    barSecond: {
      height: '100px',
    },
    barThird: {
      height: '120px',
    },
    barForth: {
      height: '140px',
    },
    barFifth: {
      height: '170px',
    },
    barSixth: {
      height: '130px',
    },
  },
  legend: {
    main: {
      marginBottom: '0.5rem',
    },
    text: {
      padding: '0.5rem',
      height: '30px',
    },
  },
  disclaimer: {
    padding: '0.5rem',
    height: '30px',
  },
  pharagraph: {
    main: {
      marginTop: '1rem',
    },
    text: {
      height: '20px',
    },
  },
};

const SkeletonLightMonthlyHistogram = (props) => {
  const [className, style] = useStyles(props);
  const { header, locationSelector, content, legend, disclaimer, pharagraph } = styles;
  return (
    <Box
      className={`${className} fr-skeleton`}
      style={style}
      dataTestId="skeletonLightMonthlyHistogram"
    >
      <Row gutters>
        <Col style={header.main}>
          <Box className="fr-skeleton-box" style={header.box}>
            <Box className="fr-skeleton-element" style={header.title} />
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col style={locationSelector.autoComplete}>
          <Box className="fr-skeleton-box" style={locationSelector.box}>
            <Box style={locationSelector.content}>
              <Box className="fr-skeleton-element" style={locationSelector.text} />
              <Box className="fr-skeleton-element" style={locationSelector.text} />
            </Box>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col>
          <Box className="fr-skeleton-box" style={content.main}>
            <Row gutters style={content.row}>
              <Col xs="2" style={content.bar}>
                <Box className="fr-skeleton-element" style={content.barFirst} />
              </Col>
              <Col xs="2" style={content.bar}>
                <Box className="fr-skeleton-element" style={content.barSecond} />
              </Col>
              <Col xs="2" style={content.bar}>
                <Box className="fr-skeleton-element" style={content.barThird} />
              </Col>
              <Col xs="2" style={content.bar}>
                <Box className="fr-skeleton-element" style={content.barForth} />
              </Col>
              <Col xs="2" style={content.bar}>
                <Box className="fr-skeleton-element" style={content.barFifth} />
              </Col>
              <Col xs="2" style={content.bar}>
                <Box className="fr-skeleton-element" style={content.barSixth} />
              </Col>
            </Row>
            <Row gutters style={legend.main}>
              <Col xs="3">
                <Box className="fr-skeleton-element" style={legend.text} />
              </Col>
            </Row>
            <Row gutters>
              <Col xs="9">
                <Box className="fr-skeleton-element" style={disclaimer} />
              </Col>
            </Row>
          </Box>
        </Col>
      </Row>
      <Row gutters>
        <Col xs="4" style={pharagraph.main}>
          <Box className="fr-skeleton-box" style={pharagraph.text} />
        </Col>
      </Row>
    </Box>
  );
};

SkeletonLightMonthlyHistogram.componentName = 'SkeletonLightMonthlyHistogram';

export default SkeletonLightMonthlyHistogram;
